/* Passive GA4 funnel events for the product page and the cart pickup step.
   Listens only: never prevents, delays or changes a click, and never touches cart-pickup.js state. */
(() => {
  // Send to the GA4 property configured by Shopify's Google app only, so the
  // linked Google tag does not count each event twice.
  const measurementId = () => (window.dataLayer || []).map(entry => Array.from(entry))
    .find(entry => entry[0] === 'config' && /^G-/.test(entry[1]))?.[1];
  window.hbTrack = (name, params = {}) => {
    try {
      const id = measurementId();
      if (typeof window.gtag === 'function' && id) window.gtag('event', name, { ...params, send_to: id });
    } catch { /* Analytics must never interrupt shopping. */ }
  };

  const form = document.querySelector('#cart');
  const panel = form?.querySelector('[data-pickup-confirmation]');
  if (!panel) return;
  const status = panel.querySelector('[data-pickup-status]');
  const confirm = panel.querySelector('[data-pickup-confirm]');
  const error = panel.querySelector('[data-pickup-error]');
  const storeIn = text => text.replace(/^Pickup: /, '').split(' — ')[0];
  let lastStore = '';
  let lastSlot = '';

  form.addEventListener('click', event => {
    const location = event.target.closest('.pickup-location');
    if (!location || !event.isTrusted) return;
    const store = location.querySelector('label')?.textContent.trim() || '';
    if (store && store !== lastStore) {
      lastStore = store;
      window.hbTrack('hb_pickup_store_selected', { store });
    }
  }, { capture: true, passive: true });

  // cart-pickup.js writes "Pickup: store — address — date, time" once a full slot is ready.
  new MutationObserver(() => {
    const text = status.textContent;
    if (!text.startsWith('Pickup: ') || text === lastSlot) return;
    lastSlot = text;
    window.hbTrack('hb_pickup_slot_ready', { store: storeIn(text) });
  }).observe(status, { childList: true, characterData: true, subtree: true });

  confirm.addEventListener('change', () => {
    if (confirm.checked) window.hbTrack('hb_pickup_confirmed', { store: storeIn(confirm.value) });
  });

  // Window capture runs before cart-pickup.js, so a blocked click is still counted.
  // Untrusted clicks are the adapter re-entering checkout after its pickup handoff.
  window.addEventListener('click', event => {
    if (event.isTrusted && event.target.closest('#checkout')) window.hbTrack('hb_checkout_click', { items: form.querySelectorAll('[name="updates[]"]').length });
  }, { capture: true, passive: true });

  // Each blocked attempt rewrites the error text, so every block is recorded once.
  new MutationObserver(() => {
    if (error.hidden) return;
    const text = error.textContent;
    const reason = /Choose an available/.test(text) ? 'slot_missing' : /Please confirm/.test(text) ? 'not_confirmed' : /couldn’t confirm/.test(text) ? 'pickup_sync_failed' : 'other';
    window.hbTrack('hb_checkout_blocked', { reason });
  }).observe(error, { childList: true });
})();
